import mySvg from "../image/meesok.png";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import LanguageIcon from "@mui/icons-material/Language";

function TopNav({ handleSubmit, handleClickOpen }) {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      className="animated-div"
    >
      <div className="relative overflow-hidden flex flex-row items-center justify-between w-[100%] px-32 md:px-40 h-[50px] bg-gradient-to-r from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 border-b border-brand-gold-300/50 shadow-card fixed top-0 left-0 z-50">
        <span
          aria-hidden="true"
          className="pointer-events-none absolute top-[-40%] bottom-[-40%] left-[-28%] w-[22%] bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-[18deg] animate-header-sheen"
        />
        <img className="w-[auto] md:h-[80%] h-[80%]" src={mySvg} alt="" />
        <div className="flex items-center bg-white/10 rounded-pill pl-2 pr-1 p-0.5 gap-0.5">
          <LanguageIcon className="text-white/80" fontSize="small" />
          <select
            value={i18n.language}
            onChange={(e) => changeLanguage(e.target.value)}
            className="bg-transparent text-white/80 text-[10px] xl:text-[12px] font-bold rounded-pill px-1 py-1 focus:outline-none focus:text-white"
          >
            <option className="text-slate-800" value="th">
              ไทย
            </option>
            <option className="text-slate-800" value="en">
              EN
            </option>
            <option className="text-slate-800" value="lo">
              ລາວ
            </option>
            <option className="text-slate-800" value="zh">
              中文
            </option>
            <option className="text-slate-800" value="vi">
              VI
            </option>
          </select>
        </div>
      </div>
    </motion.div>
  );
}

export default TopNav;
